<template>
  <div class="projectCards">
    <a class="projectCards__item" href="#!" @click.prevent="saveProjectOnly">
      <div class="projectCards__image projectCards__image--link" style="background-image: url(/svg/largeplus.svg);" />
      <h3 class="projectCards__heading headingFive">{{ buttonText }}</h3>
    </a>
    <a v-for="project in projects" :key="project.id" class="projectCards__item" :href="'/project-book/project/' + project.id">
      <div class="projectCards__image" :style="{ backgroundImage: 'url(' + ((project.hasOwnProperty('previewUrl')) ? project.previewUrl : '/images/default.jpg') + ')' }" />
      <h2 class="projectCards__heading headingFive">{{ project.name }}</h2>
    </a>
  </div>
</template>
<script>
import { eventBus } from '../app';

export default {
	props: {
		buttonText: {
			type: String,
			default: ''
		},
		initialProjectsList: {
			type: Array, 
			default: null
		}
	},
	data() {
		return {
			projects: this.initialProjectsList
		};
	},
	created() {
		eventBus.$on('project-created', this.addProject);
	},
	beforeDestroy() {
		eventBus.$off('project-created', this.addProject);
	},
	methods: {
		saveProjectOnly() {
			eventBus.$emit('save-project-only');
		},
		addProject(project) {
			this.projects.unshift(project);
		},
	}
};
</script>
